import styled from "@emotion/styled";
import { Button } from "react-aria-components";

export const PopupDialogCloseButton = styled(Button)`
  position: absolute;
  right: 8px;
  top: 8px;
  background: transparent;
  border: none;
`;
